<template>
  <div class="container-fluid">
    <div class="mt-4">
      <Breadcrumb :breadcrumbs="breadcrumbs"/>
      
      <router-view/>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/shares/Breadcrumb'
import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'

export default {
  components: { Breadcrumb },
  mixins: [BreadcrumbMixin],
  name: 'CustomTable',
}
</script>

<style scoped>

</style>